<template>
    <DsModal
        show-close
        size="fullscreen"
        class="content-preview-modal"
        :is-open="!!previewHtml"
        :title="$t('global.preview')"
        @close="$emit('close')"
    >
        <template #header>
            <slot />
        </template>

        <div class="preview">
            <DsHtmlPreview
                :html="outputHtml"
                sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox allow-downloads"
                disable-scripts
                :hide-header="hideHeader"
            />
        </div>
    </DsModal>
</template>

<script>
export default {
    name: 'HtmlContentPreviewModal',
    props: {
        previewHtml: String,
        previewImageUrl: String,
        hideHeader: Boolean,
    },

    computed: {
        outputHtml() {
            if (this.previewImageUrl) {
                return `<html><body><img style="width: 100%" src="${this.previewImageUrl}" /></body></html>`;
            }

            return this.previewHtml;
        },
    },
};
</script>

<style lang="scss" scoped>
.content-preview-modal {
    height: 100%;
}

.preview {
    width: px-to-rem(1024);
    flex: 1;
    margin: $spacing-400 auto;
    --html-preview-padding: #{$spacing-050};
}
</style>
